import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const formServices = {
  addNewFormMeta,
  updatedFormMeta,
  softDeleteRestoreFormMeta,
  deleteFormMeta,
  getFormMetaList,
  getSingleFormMeta,
};

// Add New Form Meta
async function addNewFormMeta(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFormMeta`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Form Meta
async function updatedFormMeta(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedFormMeta`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Form Meta
async function softDeleteRestoreFormMeta(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreFormMeta`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Form Meta
async function deleteFormMeta(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteFormMeta`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Form Meta
async function getFormMetaList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormMetaList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormMetaList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get All Form Meta
async function getSingleFormMeta(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleFormMeta/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}